import { ReactNode } from "react";
import styled from "styled-components";

const MainPanelAtom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  height: 100%;
  // padding: 0px 20px 0px 20px;
  box-sizing: border-box;
  box-shadow: inset 0 0 0px #ffe500;
  transtion: box-shadow 300ms;

  &.beating {
    box-shadow: inset 0 0 60px #ffe500;
  }
`

type MainPanelProps = {
    children?: ReactNode | ReactNode[]
}

export default function MainPanel({children}: MainPanelProps) {
    return (<MainPanelAtom id="mainPanel">{children}</MainPanelAtom>)
}